import TModalSection from "./TModalSection";

export default TModalSection;
